import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DeviceItem, DeviceSearchOptions } from '@models/custom-fields.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { DeviceService } from '@services/device/device.service';
import {
  Observable,
  OperatorFunction,
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  of,
  switchMap,
  tap
} from 'rxjs';
import { DomSanitizerPipe, TdsTypeAheadComponent } from 'tangoe-design-system';

@Component({
  selector: 'ts-device-select',
  templateUrl: './device-select.component.html',
  imports: [CommonModule, DomSanitizerPipe, TranslationPipe, TdsTypeAheadComponent]
})
export class DeviceSelectComponent {
  @Input() id: string;
  @Input() label: string;
  @Input() name: string;
  @Input() help_text?: string;
  @Input() required: boolean = false;
  @Input() control: FormControl;
  @Input() header_text?: string;

  no_results_found: boolean = false;
  loading: boolean = false;
  input_format = (item: DeviceItem) => item.display_value;

  constructor(private device_service: DeviceService) {}

  search: OperatorFunction<string, readonly Partial<DeviceItem>[]> = (term$: Observable<string>) =>
    term$.pipe(
      debounceTime(100),
      tap(() => (this.loading = this.no_results_found = false)),
      distinctUntilChanged(),
      switchMap((term: string) => {
        if (term.length < 3) return of([]);

        this.loading = true;
        return this.device_service.search(term).pipe(
          map((response: DeviceSearchOptions) => {
            this.loading = false;

            if (response.items.length > 0) {
              return response.items.map((item: DeviceItem) => ({
                ...item,
                display_value: `${item.device_name} | ${item.imei} | ${item.id} | ${item.person_name} | ${item.person_email}`
              }));
            }

            this.no_results_found = true;
            return [];
          }),
          catchError(() => {
            this.loading = false;
            return of([]);
          })
        );
      })
    );
}
